<template>
  <footer class="footer">
    <div class="footer__container">
      <div class="footer__cols footerCols">
        <div class="footerCols__col footerCols__col--1 footerColsInfo">
          <div class="footer__logo">
            <logo />
          </div>

          <p class="footerColsInfo__text">
            {{
              $t(
                "ULTIMA FARM is a registered trademark of PLATINEX Limited Liability Company. Its use does not imply any affiliation with or endorsement by it."
              )
            }}
          </p>
          <p class="footerColsInfo__text">
            {{
              $t(
                "The ULTIMA FARM image was created via a logo contest. The ULTIMA FARM is a registered logo and brand identity. Its unauthorized use is prohibited."
              )
            }}
          </p>
        </div>

        <div class="footerCols__col footerCols__col--3">
          <footer-menu-col :title="$t(`Help`)">
            <ul class="footerCols__menu footerMenu">
              <li
                v-for="(itemMenu, index) in menuFooter2"
                :key="index"
                class="footerMenu__item"
              >
                <a
                  v-if="typeof itemMenu.to === 'string'"
                  class="footerMenu__link"
                  target="_blank"
                  :href="getUrl(itemMenu.to)"
                >
                  {{ itemMenu.label }}
                </a>
                <a
                  v-else
                  class="footerMenu__link"
                  @click="onClick(itemMenu.to)"
                >
                  {{ itemMenu.label }}
                </a>
              </li>
            </ul>
          </footer-menu-col>
        </div>

        <div class="footerCols__col footerCols__col--2">
          <footer-menu-col :title="$t(`Social Network`)">
            <div class="footerCols__menu">
              <div class="footerSocials">
                <a
                  href="https://t.me/plcultima"
                  title="@plcultima"
                  class="footerSocials__link"
                  target="_blank"
                >
                  <icon-tg class="footerSocials__icon" />
                </a>
                <a
                  href="https://www.youtube.com/channel/UCiZpQJidXGL7PPcJFXHkMMA"
                  title="PLC ULTIMA"
                  class="footerSocials__link"
                  target="_blank"
                >
                  <icon-youtube class="footerSocials__icon" />
                </a>
                <a
                  href="https://www.facebook.com/groups/plcultima"
                  title="plcultima"
                  target="_blank"
                  class="footerSocials__link"
                >
                  <icon-facebook class="footerSocials__icon" />
                </a>
                <a
                  href="https://twitter.com/plcultima"
                  title="@PlcUltima"
                  target="_blank"
                  class="footerSocials__link"
                >
                  <icon-twitter class="footerSocials__icon" />
                </a>
              </div>
            </div>
          </footer-menu-col>
        </div>

        <div class="footerCols__col footerCols__col--4">
          <footer-menu-col :title="$t('Language')">
            <div
              class="footerCols__langSelect langSelect"
              menu-name="lang_footer"
            >
              <div
                class="langSelect__current tooltip-link"
                @click.prevent.stop="toggleLanguageDropdownMenu"
              >
                <span class="langSelect__flag flag" :class="`flag--${lang}`" />
                <span class="langSelect__text">{{ languages[lang] }}</span>
                <gl-svg-icon
                  icon="arrow-down"
                  class="langSelect__icon"
                  :class="{ 'langSelect__icon--up': languageDropdown }"
                />
              </div>
              <transition name="fade">
                <ul
                  v-if="languageDropdown"
                  class="footerCols__lang lang tooltip-content"
                >
                  <li
                    v-for="(l, index) in languages"
                    :key="index"
                    :class="lang === index ? 'lang__item--special' : ''"
                    class="lang__item"
                  >
                    <a
                      class="lang__link"
                      href="#"
                      @click.prevent.stop="setLang(index)"
                    >
                      <span class="lang__flag flag" :class="`flag--${index}`" />
                      {{ $t(l) }}
                      <gl-svg-icon
                        v-if="lang === index"
                        icon="tick"
                        class="lang__tick"
                      />
                    </a>
                  </li>
                </ul>
              </transition>
            </div>
          </footer-menu-col>
        </div>
      </div>

      <div class="footer__copyright">
        {{ new Date().getFullYear() }}
        PLATINEX Limited Liability Company, 88 Avtomshenebeli Street, Hualing Kutaisi Free Industrial Zone, City of Kutaisi, Georgia
        <br />
        {{ $t("ALL RIGHTS RESERVED") }}
      </div>
    </div>
  </footer>
</template>

<script>
import FooterMenuCol from "./components/FooterMenuCol";

import Logo from "@/assets/img/footer-logo.svg?inline";
import IconFacebook from "@/assets/img/socials/icon-facebook.svg?inline";
import IconTg from "@/assets/img/socials/icon-tg.svg?inline";
import IconTwitter from "@/assets/img/socials/icon-tw.svg?inline";
import IconYoutube from "@/assets/img/socials/icon-youtube.svg?inline";
import { menuFooter2 } from "@/components/Menu/menu";
import { languages } from "@/config";
import { EventBus } from "@/event-bus";
import { refreshPage } from "@/mixins";

import GlSvgIcon from "@/shared/GlSvgIcon";

export default {
  name: "FooterMenu",
  components: {
    GlSvgIcon,
    FooterMenuCol,
    Logo,
    IconFacebook,
    IconTg,
    IconTwitter,
    IconYoutube,
  },
  mixins: [refreshPage],
  data() {
    return {
      languages,
      languageDropdown: false,
    };
  },
  computed: {
    lang() {
      return this.$i18n.locale;
    },
    menuFooter2() {
      return menuFooter2.call(this);
    },
  },
  mounted() {
    const fnDClick = (name) => {
      if (name !== "lang_footer") this.languageDropdown = false;
    };
    EventBus.$on("d-click", fnDClick);
    this.$once("hook:beforeDestroy", () => {
      EventBus.$off("d-click", fnDClick);
    });
  },
  methods: {
    setLang(selectedLang) {
      this.languageDropdown = false;
      this.$i18n.locale = selectedLang
      this.$router.push({ name: this.$route.name, params: { locale: selectedLang } })
    },
    onClick(val = {}) {
      if (typeof val === "string") {
        let href = this.$router.resolve(val).href;
        window.open(href, "_blank");
      } else {
        this.$router.push(val);
      }
    },
    getUrl(val = {}) {
      return typeof val === "string" ? val : this.$router.resolve(val).href;
    },
    toggleLanguageDropdownMenu() {
      this.languageDropdown = !this.languageDropdown;
      // EventBus.$emit('d-click', 'lang_footer')
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~styles/blocks/flag";

.footer {
  background-color: #111a3a;

  &__container {
    padding: 64px 16px 16px;

    @media (min-width: $breakpoint-md) {
      padding: 64px 16px 32px;
    }

    @media (min-width: $breakpoint-xl) {
      margin: 0 auto;
      max-width: 1200px;
      padding: 96px 16px 32px;
    }
  }

  &__logo {
    margin-bottom: 32px;
  }

  &__copyright {
    @include text-body-3;

    color: rgba(#fff, 0.3);
    margin-top: 64px;
    text-align: center;
    text-transform: uppercase;

    @media (min-width: $breakpoint-xl) {
      margin-top: 96px;
    }
  }
}

.footerCols {
  display: grid;
  gap: 32px;
  //flex-wrap: wrap;

  @media (min-width: $breakpoint-md) {
    display: grid;
    gap: 32px 16px;
    grid-template-columns: 40% 22% auto;
    grid-template-rows: min-content 1fr;
    justify-content: space-between;
  }

  @media (min-width: $breakpoint-xl) {
    grid-template-columns: 35% auto auto 160px;
  }

  &__col {
    //width: 100%;
    //
    //@media (min-width: $breakpoint-md) {
    //  padding: 0 16px;
    //}

    //& + & {
    //  margin-top: 32px;
    //
    //  @media (min-width: $breakpoint-md) {
    //    margin-top: 0;
    //  }
    //}

    &--1 {
      @media (min-width: $breakpoint-md) {
        //width: 40%;
        grid-row: span 2;
      }
      //
      //  @media (min-width: $breakpoint-xl) {
      //    width: 35%;
      //  }
    }

    //&--2 {
    //  @media (min-width: $breakpoint-md) {
    //    width: 30%;
    //  }
    //
    //  @media (min-width: $breakpoint-xl) {
    //    width: 19%;
    //  }
    //}

    &--3 {
      @media (min-width: $breakpoint-md) {
        //    width: 30%;
        grid-row: span 2;
      }
      //
      //  @media (min-width: $breakpoint-xl) {
      //    width: 23%;
      //  }
    }

    //&--4 {
    //  @media (min-width: $breakpoint-md) {
    //    margin-right: 0;
    //    margin-left: auto;
    //    margin-top: 32px !important;
    //    width: 30%;
    //  }
    //
    //  @media (min-width: $breakpoint-xl) {
    //    margin-top: 0 !important;
    //    width: 20%;
    //  }
    //}
  }

  &__lang {
    left: 0;
    margin-top: 10px;
    max-height: 200px;
    overflow: auto;
    right: 0;
    top: 100%;

    @media (min-width: $breakpoint-md) {
      max-height: 100px;
    }

    @media (min-width: $breakpoint-xl) {
      max-height: 250px;
    }
  }

  &__langSelect {
    line-height: 24px;
    padding-top: 16px;
    position: relative;

    @media (min-width: $breakpoint-md) {
      max-width: 200px;
      padding-top: 0;
    }

    &__text {
      color: #fff;
    }
  }

  &__menu {
    padding-top: 32px;

    @media (min-width: $breakpoint-md) {
      padding-top: 0;
    }
  }
}

.footerColsInfo {
  &__text {
    @include text-body-1;

    color: rgba(255, 255, 255, 0.3);

    & + & {
      margin-top: 24px;
    }
  }
}

.footerMenu {
  &__item {
    display: flex;

    &::before {
      align-items: center;
      color: #fff;
      content: "\2014";
      display: flex;
      flex-shrink: 0;
      font-weight: 700;
      height: 24px;
      margin-right: 16px;
    }

    & + & {
      margin-top: 12px;

      @media (min-width: $breakpoint-md) {
        margin-top: 8px;
      }
    }
  }

  &__link {
    @include text-body-1;

    display: flex;
    color: #fff;
    cursor: pointer;
  }
}

.footerSocial {
  &__list {
    display: flex;
  }

  &__item {
    & + & {
      margin-left: 32px;

      @media (min-width: $breakpoint-md) {
        margin-left: 10px;
      }
    }
  }

  &__link {
    color: rgba(243, 228, 133, 0.5);
    cursor: pointer;
    transition: all 0.3s linear;
    vertical-align: middle;

    &:hover {
      color: rgba(243, 228, 133, 1);
    }
  }
}

.lang {
  @include scrollbar;

  display: flex;
  flex-wrap: wrap;

  &__item {
    flex-basis: 100%;
    position: relative;

    &--special {
      font-weight: 700;
    }
  }

  &__link {
    @include text-body-2;

    align-items: center;
    background-color: #fff;
    display: flex;
    height: 46px;
    line-height: 46px;
    padding-left: 15px;

    &:hover {
      background-color: #f3f3f3;
    }
  }

  &__flag {
    flex-shrink: 0;
    margin-right: 16px;
  }

  &__tick {
    margin-left: auto;
    margin-right: 0;
  }
}

.langSelect {
  &__current {
    @include text-body-1;

    align-items: center;
    cursor: pointer;
    display: flex;
    position: relative;
  }

  &__flag {
    margin-right: 16px;
  }

  &__icon {
    color: #fff;
    filter: invert(1);
    margin-left: auto;
    margin-right: 0;
    transition: transform 0.3s ease;

    &--up {
      transform: rotate(180deg);
    }
  }
}

.tooltip-link {
  cursor: pointer;
  color: #fff;
  border-bottom: none;
}

.tooltip-content {
  position: absolute;
  z-index: 4;
  height: 100px;

  @media (min-width: $breakpoint-md) {
    height: 200px;
  }

  @media (min-width: $breakpoint-xl) {
    height: 300px;
  }
}

.footerSocials {
  display: flex;
  gap: 16px;

  &__link {
    cursor: pointer;
    display: flex;
    opacity: 0.5;
    transition: opacity 0.3s;

    &:hover {
      opacity: 1;
    }
  }

  &__icon {
    height: 24px;
    width: 24px;

    ::v-deep path {
      fill: #649af1;
    }
  }
}
</style>
